
import { ref } from 'vue';
import IftaLabel from 'primevue/iftalabel';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { external } from '../apis/external';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'ForgotPassword',
	components: {
		IftaLabel,
		InputText,
		Button,
		PopupMainNavbar,
		PopupSubNavbar: PopupAffiliateNavbar,
	},
	props: {
		close: Function,
	},
	setup(props) {
		const toast = useToast();

		const form = ref({
			phone: {
				value: '',
				invalid: false,
				msgErr: '',
			},
			btn: {
				loading: false,
				disabled: false,
			},
		})

		const handleSubmit = async () => {
			form.value.btn.loading = true;
			form.value.phone.invalid = false;
			form.value.phone.msgErr = '';

			try {
				const cleanedPhone = form.value.phone.value;

				if (!cleanedPhone || cleanedPhone.length !== 10) {
					form.value.phone.invalid = true;
					return;
				}

				const resp = await external.forgotPass({ phone: cleanedPhone });

				if (resp.code !== '0') {
					form.value.phone.invalid = true;
					form.value.phone.msgErr = resp.message || 'เกิดข้อผิดพลาดบางอย่าง';
					return;
				}
				toast.add({ severity: 'success', summary: 'สำเร็จ', life: 3000 });
				props.close?.();
			} catch (error: any) {
				form.value.phone.invalid = true;
				form.value.phone.msgErr = error;
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาด', detail: error, life: 3000 });
			} finally {
				form.value.btn.loading = false;
			}
		};

		return {
			form,
			handleSubmit,
		};
	},
};
